var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTadaLogoSmallLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 48.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e95642;\n      }\n\n      .cls-2 {\n        fill: #32bbce;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.1,18.69l12.13-3.55L45.1,33.46a36.22,36.22,0,0,0,3,5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.39,0l9.45,0L42.71,12.3A36,36,0,0,0,42.08,19v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,41.05,13.4,34.1,57.48,48.54l.15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.54,48.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.63,0A29.72,29.72,0,0,1,100,9.26H80.58v37.5a31.32,31.32,0,0,1-11,2h0V9.26H53.91L48,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTadaLogoSmallLight);
export default __webpack_public_path__ + "static/media/tada-logo-small-light.194e2102b95aeb0e736b4b280b182309.svg";
export { ForwardRef as ReactComponent };